<div class="row">
  <div class="col">
    <h3>SCR - Importação de arquivo 'DOC3056'</h3>
  </div>

  <!--div class="col-auto">
    <div class="btn-group" ngbDropdown role="group">
      <button class="btn btn-primary" ngbDropdownToggle><i class="fa fa-cloud-download-alt"></i> Importar Automaticamente</button>
      <div class="dropdown-menu" ngbDropdownMenu>
        <button ngbDropdownItem (click)="importarAutomaticamente()">Pelo arquivo de controle</button>
        <button ngbDropdownItem (click)="importarReferenciaEspecifica()">Referência específica</button>
      </div>
    </div>
  </div-->

  <div class="col-auto">
    <button class="btn btn-secondary" type="button" (click)="limpar()" placement="bottom">
      <i class="fa fa-file"></i> Limpar</button>
  </div>

  <div class="col-auto">
      <button class="btn btn-primary" (click)="voltar()" type="button">Voltar</button>
    </div>

  <div class="col-auto">
    <button *ngIf="!enviado" [disabled]="!importacaoScrForm.valid || importacaoScrForm.pristine" type="button" (click)="onSubmit()"
      class="btn btn-primary" type="button">Enviar</button>
  </div>
</div>

<div class="col">
  <p>Carga de arquivo do SCR</p>
</div>

<div class="container">
  <form [formGroup]="importacaoScrForm" (validSubmit)="onSubmit()">
    <div class="row">
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="referencia">Referência:<i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Mês/ano de referência do arquivo (MM/AAAA)"></i></label>
        <input type="text" class="form-control" bnMask="MESANO" formControlName="referencia">
      </div>

      <div class="bn-form-group col-md-1">
      </div>

      <div class="bn-form-group col-md-6">
        <label class="form-label" for="arquivo">Arquivo:<i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Informe o arquivo JSON do SCR do BACEN"></i></label>
        <div id="customFile">
          <input type="file" accept=".xml" class="form-control" id="arquivo" (change)="onFileChange($event)" #fileInput [disabled]="enviado" formControlName="arquivo"/>
          <label class="form-label" for="arquivo" data-browse="Selecione"></label>
        </div>
      </div>
    </div>
  </form>
</div>

<div *ngIf="ocorrencias?.length > 0" class="erros-upload">
  <div class="row">
    <div class="col">
      <h4>Erros importação do arquivo</h4>
    </div>
  </div>
</div>

<div>
  <div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
      <table class="table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">
              Erro(s) encontrado(s)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ocorrencia of ocorrencias">
              <td width="80%">
                  {{ ocorrencia.mensagem }}
              </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<bn-loading-overlay></bn-loading-overlay>
